import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export default function LanguageSwitcher({ style }) {
  const { lang, toggleLang } = useLanguage();

  return (
    <button
      onClick={toggleLang}
      style={{
        background: 'rgba(255,255,255,0.1)',
        border: '1px solid rgba(255,255,255,0.2)',
        borderRadius: 6,
        padding: '4px 10px',
        cursor: 'pointer',
        fontSize: 12,
        fontWeight: 700,
        color: 'inherit',
        letterSpacing: 1,
        transition: 'all 0.2s',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        ...style,
      }}
      title={lang === 'es' ? 'Switch to English' : 'Cambiar a Español'}
    >
      <span style={{ opacity: 0.7, fontWeight: 400 }}>
        {lang === 'es' ? 'ES' : 'EN'}
      </span>
      <span style={{ fontSize: 10 }}>▸</span>
      <span>
        {lang === 'es' ? 'EN' : 'ES'}
      </span>
    </button>
  );
}
